import { FC } from "react";

interface BuildingsProps {
  color?: string;
}

const Buildings: FC<BuildingsProps> = ({ color = "black" }) => {
  return (
    <>
      <svg
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3739 7.03914C11.9833 6.64861 11.3502 6.64861 10.9596 7.03914L3.20964 14.7891C3.0221 14.9767 2.91675 15.231 2.91675 15.4962V28.6654C2.91675 29.2176 3.36446 29.6654 3.91675 29.6654H19.4167C19.969 29.6654 20.4167 29.2176 20.4167 28.6654V15.4962C20.4167 15.231 20.3114 14.9767 20.1239 14.7891L12.3739 7.03914ZM17.5001 26.7487H13.1251V23.3737C13.1251 22.8214 12.6774 22.3737 12.1251 22.3737H11.2084C10.6561 22.3737 10.2084 22.8214 10.2084 23.3737V26.7487H5.83341V16.7067C5.83341 16.4414 5.93877 16.1871 6.12631 15.9996L10.9596 11.1662C11.3502 10.7757 11.9833 10.7757 12.3739 11.1662L17.2072 15.9996C17.3947 16.1871 17.5001 16.4414 17.5001 16.7067V26.7487ZM13.1251 18.457C13.1251 19.0093 12.6774 19.457 12.1251 19.457H11.2084C10.6561 19.457 10.2084 19.0093 10.2084 18.457V17.5404C10.2084 16.9881 10.6561 16.5404 11.2084 16.5404H12.1251C12.6774 16.5404 13.1251 16.9881 13.1251 17.5404V18.457ZM25.2501 29.6654C25.8024 29.6654 26.2501 29.2176 26.2501 28.6654V13.09C26.2501 12.8248 26.1447 12.5704 25.9572 12.3829L20.1992 6.62492C20.0117 6.43739 19.7573 6.33203 19.4921 6.33203H18.1935C17.3026 6.33203 16.8564 7.40917 17.4864 8.03914L23.0405 13.5933C23.2281 13.7808 23.3334 14.0352 23.3334 14.3004V28.6654C23.3334 29.2176 23.7811 29.6654 24.3334 29.6654H25.2501ZM31.0834 29.6654C31.6357 29.6654 32.0834 29.2176 32.0834 28.6654V10.6692C32.0834 10.4039 31.9781 10.1496 31.7905 9.96205L28.4534 6.62492C28.2659 6.43739 28.0115 6.33203 27.7463 6.33203H26.4476C25.5567 6.33203 25.1106 7.40917 25.7405 8.03914L28.8739 11.1725C29.0614 11.36 29.1667 11.6144 29.1667 11.8796V28.6654C29.1667 29.2176 29.6145 29.6654 30.1667 29.6654H31.0834Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default Buildings;
